import React from "react"
import { Container, Paper, AppBar, Toolbar, Grid } from "@mui/material"
import { LOGIN_ROUTE } from "../../../../constants/routes"
import FacilitynetLogo from "../../../../shared/layouts/assets/facilit-net-logo.svg"
import { LanguageSelector } from "../../../../shared/components/languageSelector/LanguageSelector"
import { Link, Outlet } from "react-router-dom"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles<{ fullWidth: boolean }>()((_, { fullWidth }) => ({
    container: {
        padding: "8rem 0",
    },
    paper: {
        padding: " 0 1rem",
        display: "flex",
        flexDirection: "column",
        maxWidth: fullWidth ? "none" : "37rem",
        margin: fullWidth ? 0 : "0 auto",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
    },
    logo: {
        width: "auto",
    },
    logoLink: {
        display: "flex",
        alignItems: "center",
    },
}))

type Props = Readonly<{
    fullWidth?: boolean
}>

export function PublicLayout({ fullWidth = false }: Props) {
    const { classes } = useStyles({ fullWidth })

    return (
        <Container className={classes.container}>
            <AppBar position="fixed" color="transparent" elevation={0}>
                <Toolbar>
                    <Grid container justifyContent="space-between" className={classes.header}>
                        <Link className={classes.logoLink} to={LOGIN_ROUTE}>
                            <img className={classes.logo} src={FacilitynetLogo} alt="Facilitynet" />
                        </Link>
                        <LanguageSelector color="black" />
                    </Grid>
                </Toolbar>
            </AppBar>

            <Paper className={classes.paper} elevation={0}>
                <Outlet />
            </Paper>
        </Container>
    )
}
